import Vue from 'vue';
import register from '@/components/form/register';
import emblem from '@/components/emblem';

Vue.component('login-block', {
    components: {
        emblem,
        register
    },
    props: {
        initialShowForm: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            showForm: false
        };
    },
    created() {
        this.showForm = this.initialShowForm;
    },

    methods: {
        toggleShowForm() {
            this.showForm = !this.showForm;
        }
    }
});
